<template>
  <div class="rule" :class="{ 'white-mode': !darkMode }">
    <div class="rule__scroll">
      <div class="rule__wrap">
        <p class="rule__whitehint">注销风险说明</p>
        <p class="rule__p">
          【特别说明】亲爱的用户，在您正式开始下一步极氪订阅账号注销流程前，我们先为您做出如下特别说明：
        </p>
        <p class="rule__p rule__p--mgt20">
          注销极氪订阅账号后，您将无法再以此账号登录和使用【浙江极氪智行科技服务有限公司或其关联公司】（以下简称“我们”）的相关产品与服务，我们也将同时终止为该账号提供我们的高品质、多元化的产品与服务，这同时也不可避免地会给您的售后维权带来不便。<span>且极氪订阅账号一旦注销完成，将无法恢复。</span>请您再注销前慎重考虑。
        </p>
        <p class="rule__p rule__p--mgt20">
          若您经过慎重考虑后仍执意决定注销极氪订阅账号的，请您务必先行仔细阅读和充分理解本《注销风险说明》，在同意全部内容后，按照我们的注销操作指引点击进行下一步操作，您勾选本注销协议并点击下一步注销操作的行为即视为您已经同意签署和遵守本协议全部内容。如您在注销后需要再次使用我们的服务的，欢迎您使用手机号码或我们允许的其他方式重新注册。同时，我们也非常希望能够了解您使用我们的产品/服务体验，您可以通过客服或发邮件至【zeekrsubscription@zeekr.com】的方式反馈给我们，以便我们进一步改进和完善我们的产品和服务。
        </p>
        <p class="rule__p rule__p--white rule__p--mgt20">
          （如您执意决定注销极氪订阅账号的，请继续向下阅读）
        </p>
        <p class="rule__p rule__p--flex rule__p--mgt20">
          <view class="rule__index">一、</view
          >您需要首先知悉的是：账号注销将会对您产生如下影响：
        </p>
        <p class="rule__p rule__p--flex rule__p--mgt20">
          <view class="rule__index">1.</view
          >极氪订阅账号一旦注销，您将无法登录、使用该账号（也包括无法再使用该账号作为第三方账号登录其他产品），也就是说您将无法再以此账号登录/使用/继续使用我们旗下的相关产品与服务；
        </p>
        <p class="rule__p rule__p--flex">
          <view class="rule__index">2.</view
          >极氪订阅账号一旦注销，您曾通过该账号登录、使用的产品与服务下的所有内容、信息、数据、记录将会被删除或匿名化处理，您也无法再检索、访问、获取、继续使用和找回，也无权要求我们找回（但法律法规另有规定或监管部门另有要求的除外），包括：该账号下的个人资料（例如：头像、昵称等）及绑定信息（例如：绑定手机号等）；该账号下的您的个人信息（同时您亦不再享有《极氪订阅隐私政策》中约定的您的用户权利，但法律法规另有规定的除外）；该账号曾发表的所有内容（例如：评论、互动、聊天记录等）；
        </p>
        <p class="rule__p rule__p--flex">
          <view class="rule__index">3.</view
          >您申请账号注销的行为即表明您同意放弃该账号在我们旗下的产品与服务使用期间已产生的但未消耗完毕的权益及未来的预期利益。即极氪订阅账号一旦注销，我们将会对该账号下的全部权益做清除处理，包括：优惠或权益会员等级、权益、卡券、成长值、积分、邀请记录将视为自动放弃而清除；
        </p>
        <p class="rule__p rule__p--flex">
          <view class="rule__index">4.</view
          >极氪订阅账号一旦注销，您与我们曾签署过的相关用户协议、其他权利义务性文件等相应终止（但我们与您之间已约定继续生效的或法律法规另有规定的除外）。
        </p>
        <p class="rule__p rule__p--flex">
          <view class="rule__index">5.</view
          >极氪订阅app账户注销后将无法恢复。若您再次注册极氪订阅账户，您的身份将会被使用为老用户，新用户的专属权益将不再享有；
        </p>
        <p class="rule__p rule__p--flex">
          <view class="rule__index">6.</view>其他因极氪订阅账号注销产生的结果。
        </p>
        <p class="rule__p rule__p--flex rule__p--mgt20">
          <view class="rule__index">二、</view
          >在您向我们申请注销极氪订阅账号之前或正在申请注销极氪订阅账号的过程中，为保障您的账号安全和财产权益，请您先行检查与确保您申请注销的极氪订阅账号已经同时满足以下几点，包括：
        </p>
        <p class="rule__p rule__p--flex rule__p--mgt20">
          <view class="rule__index">1.</view
          >该账号是通过我们的官方渠道注册、符合《极氪订阅用户服务协议》及相关平台说明规范的账号；且为您本人注册的账号；
        </p>
        <p class="rule__p rule__p--flex">
          <view class="rule__index">2.</view
          >极氪订阅app的订单已经完成。订单说明中账号下所有订单均已完成、已取消、已退款，包括但不限于订阅订单、充电订单；且订单中并无纠纷。
        </p>
        <p class="rule__p rule__p--flex">
          <view class="rule__index">3.</view
          >其他为了保障您的账号安全和财产权益需要满足的内容。
        </p>
        <p class="rule__p rule__p--flex rule__p--mgt20">
          <view class="rule__index">三、</view>
          <view>账号注销步骤<br />您可以通过以下图示进行账号注销：</view>
        </p>
        <img
          class="rule__img"
          src="https://subscribe-prod-oss.oss-cn-hangzhou.aliyuncs.com/miniapp-ico/images/account-write-off-rule.png"
        />
        <p class="rule__p">
          <span
            >上述问题您可首先尝试自行处理，如您无法处理的或在处理过程中有任何疑惑的，可联系极氪订阅客服协助处理。<br />当您通过注销账号页面确认申请注销账号，代表您同意并接受风险事项。</span
          >
        </p>
        <p class="rule__p rule__p--mgt20">
          本协议之效力、解释、变更、执行与争议解决均适用中华人民共和国法律。因本协议产生之争议，双方尽最大诚意进行友好协商，如果双方不能协商一致，均应依照中华人民共和国法律予以处理，并由<span>被告所在地人民法院</span>管辖。
        </p>
      </div>
    </div>
    <div class="rule__bottom">
      <div>
        如需注销账号，请联系我们
        <a href="tel:4000036036">400 003 6036</a>
      </div>
    </div>
  </div>
</template>
<script setup>
import { ref } from "vue";
import { useRoute } from "vue-router";
const route = useRoute();
const darkMode = ref(true);
if (route.query && route.query.mode === "white") {
  darkMode.value = false;
}
</script>
<style lang="scss" scoped>
.rule {
  background: #0b0b0b;
  width: 100vw;
  height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.white-mode{
 background-color: #fafafa;
 color: #232323;
 .rule__scroll, .rule__bottom{
  color: #232323;
 }
 .rule__p.rule__p--white, .rule__whitehint{
  color: black;
 }
}
.rule__list {
  margin-top: 40px;
  border-top: 2px solid #474747;
}
.rule__scroll {
  width: 100%;
  box-sizing: border-box;
  height: 1%;
  flex-grow: 1;
  overflow: auto;
  font-size: 24px;
  color: #9da2a5;
}
.rule__wrap {
  padding: 30px;
}
.rule__bottom {
  flex-shrink: 0;
  padding-top: 20px;
  padding-bottom: calc(env(safe-area-inset-bottom) + 20px);
  font-size: 24px;
  font-weight: 400;
  line-height: 34px;
  color: #9da2a5;
  text-align: center;
}
.rule__bottom a {
  display: inline;
  font-size: 24px;
  color: #00cab7;
}
.rule__img {
  width: 100%;
  margin: 20px 0;
  display: block;
}
.rule__p.rule__p--mgt20 {
  margin-top: 20px;
}
.rule__p.rule__p--white {
  color: #fff;
}
.rule__p span {
  text-decoration-line: underline;
}
.rule__p.rule__p--flex {
  display: flex;
}
.rule__index {
  margin-right: 5px;
  flex-shrink: 0;
}
.rule__whitehint {
  color: #fff;
  font-size: 40px;
  margin-bottom: 30px;
}
</style>
